import { type ComponentProps } from 'react'

import type { AnalyticsPlacementTypes } from '@core/analytics'
import { useHydratedValue } from '@muse-web/router'
import type { TAudioSimple, TPlaylist } from '@core/models'
import { PlaybackButton } from '@ds/components'
import { sendPlayPauseClick } from '../helpers/sendPlayPauseClick'
import { useAudioPlayback } from '../hooks/useAudioPlayback'

type TPlayButtonContainerProps = {
    audio: TAudioSimple
    placement: AnalyticsPlacementTypes
    /** Queue this track belongs to; without it playback starts a single-track playlist. */
    playlist?: TPlaylist
    size?: ComponentProps<typeof PlaybackButton>['size']
    variant?: ComponentProps<typeof PlaybackButton>['variant']
    testID?: ComponentProps<typeof PlaybackButton>['testID']
}

export const PlayButtonContainer = ({
    audio,
    placement,
    playlist,
    size = 'small',
    variant = 'colorful',
    testID,
}: TPlayButtonContainerProps) => {
    const { isActiveAudio, isPlaying, playPause } = useAudioPlayback(audio, playlist)
    const isPlayingShown = useHydratedValue(isPlaying, false)

    const handleClick = () => {
        sendPlayPauseClick(audio.id, placement, !isActiveAudio || !isPlaying)
        playPause()
    }

    return (
        <PlaybackButton
            disabled={!audio.transcodingUrl}
            playing={isPlayingShown}
            size={size}
            variant={variant}
            testID={testID}
            labelAs={variant === 'plain' ? 'aria' : 'text'}
            onClick={handleClick}
        />
    )
}
